import * as React from 'react';

import './radio-group-item.css';
import clsx from 'clsx';

interface RadioGroupItem extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  group: string;
  scale: 'small' | 'medium' | 'large';
  kind?: 'default' | 'danger';
}

const RadioGroupItem = React.forwardRef<HTMLInputElement, RadioGroupItem>(
  ({ label, group, scale, disabled, kind = 'default', id, ...props }, ref) => {
    // Two groups can share labels, so a caller-given id wins over the label.
    const inputId = id ?? `${label}`;

    const className = clsx('radio-group-item', {
      [`radio-group-item-${scale}`]: scale,
      [`radio-group-item-${kind}`]: kind,
      'radio-group-item-disabled': disabled,
    });

    return (
      <div className={className}>
        <input
          type="radio"
          id={inputId}
          name={group}
          disabled={disabled}
          ref={ref}
          {...props}
        />
        {label && <label htmlFor={inputId}>{label}</label>}
      </div>
    );
  },
);

export { RadioGroupItem };
